import { weightedVoronoi } from 'd3-weighted-voronoi';
import * as d3Base from "d3";
import mallCSV  from '../resources/map/mall_illustrated_map.csv';
const d3 = Object.assign(d3Base, { weightedVoronoi });

// setup parameters
let multiplier = 0.15;
let mallLocs;
let origImgHeight = 4500;
let origImgWidth = 7119;
let intCircScale = 0.7; // scale factor for the interation circles on the landmarks
let height = multiplier * origImgHeight;
let width = multiplier * origImgWidth;

// This will hold voronoi coordinates as an array
let cells;

// cellLiner function for getting path instrictions from coordinates
let cellLiner = d3.line()
    								.x(d => d[0])
    								.y(d => d[1]);

// important selections
let svg = d3.select('svg.voronoi');


async function readAndDraw(history){
  // read in teh data of location coordinates of important landmarks
  mallLocs = await d3.csv(mallCSV);

  // defining the weighted voronoi function
  let weightedVoronoi = d3.weightedVoronoi()
                          .x(d => +d.X * multiplier)
                          .y(d => +d.Y * multiplier)
                          .weight(d => +d.radius * 8) // scaling by 8 to make teh weighting more prominent
                          .clip([[0,0], [0,height], [width, height], [width,0]]);

  // using the function to compute cells
  cells = weightedVoronoi(mallLocs);

  // scale for assigning stroke widths
  let radii = mallLocs.map(d => d.radius);
  let minRad = d3.min(radii);
  let maxRad = d3.max(radii);

  let strokeSScale = d3.scaleLinear()
                        .domain([0, maxRad])
                        .range([1, 2]);

  // vornoi paths will be places as paths within clipPath elements within defs
  d3.select('svg.voronoi')
    .append('defs')
    .selectAll('clipPath')
    .data(cells)
    .enter()
    .append('clipPath')
    .attr('id', (d, i) => "index" + d.site.originalObject.idx) // unique id to identify the sites in voronoi cell data and original data
    .append('path')
    .attr('d', d => cellLiner(d) + "z")
    .style('fill', 'grey')
    .style('fill-opacity', 0.2)
    .style('stroke', 'black');

  // cirular regions for each landmark that will be clipped by the voronoi paths
  d3.select('svg.voronoi')
    .selectAll('circle')
    .data(mallLocs)
    .enter()
    .append('circle')
    .classed('voronoiCirc', true)
    .attr('id', (d, i) => `circle${i}`)
    .attr("clip-path", function(d, i) { return "url(#index" + d.idx + ")"; })
    //Bottom line for safari, which doesn't accept attr for clip-path
    .style("clip-path", function(d, i) { return "url(#index" + d.idx + ")"; })
    .attr('cx', d => +d.X * multiplier)
    .attr('cy', d => +d.Y * multiplier)
    .attr('r', d => (+d.radius * multiplier)*1.3)
    .style('fill', 'brown')
    .style('fill-opacity', 0.0)

  // defining events

  function computeViewBoxScale() {
    let viewBoxScaleFactor;

    if (window.innerWidth > 1024) {
      viewBoxScaleFactor = (0.7*(window.innerWidth - 80))/1068;
    }
    else if (window.innerWidth > 500) {
      if (window.innerWidth > 600) {
        viewBoxScaleFactor = (0.85*(window.innerWidth))/1068;
      }
      else {
        viewBoxScaleFactor = (1.5*(window.innerWidth))/1068;
      }
    }
    else {
      viewBoxScaleFactor = (1.5*(window.innerWidth))/1068;
    }
    return viewBoxScaleFactor;
  }


  // important selections
  let clippedCircs = d3.select('svg.voronoi').selectAll('circle.voronoiCirc');
  clippedCircs.on('mouseover', function(d, i){
    // getting key data
    let loc = d.Location;
    let X = +d.X;
    let Y = +d.Y;
    let font = d.fontSize + "px";
    let radius = +d.radius;

    d3.select('.tooltip_container').append('div')
      .classed('tooltip', true)
      .attr('id', 'tooltip')
      .style('position', 'absolute')
      .style('left', ((X * multiplier * computeViewBoxScale()) - 70) + 'px')
      .style('top', (d.ToolY * multiplier * computeViewBoxScale()) + 15 + 'px')
      .style('width', '140px')
      .style('min-height', '70px')
      .style('padding', '8px')
      .style('box-sizing', 'border-box')
      .style('border-radius', '4px')
      .style('border', '1px solid #424242')
      .style('background', 'rgba(255, 223, 130, 0.90)')
      .style('opacity', '0')
      .style('display', 'flex')
      .style('flex-direction', 'column')
      .style('justify-content', 'center')
      .style('align-items', 'center')
      .style('overflow', 'hidden')
      .transition()
      .ease(d3.easeQuadInOut)
      .duration(250)
      .style('opacity', '1')
      .style('top', (d.ToolY * multiplier * computeViewBoxScale()) + 'px');

    d3.select('#tooltip')
      .append('p')
      .classed("tooltip_text", true)
      .style("color", "#212121")
      .style("font-size", font)
      .style("text-align", "center")
      .style('font-family', 'DM Serif Display')
      .style("margin", "3px 0px")
      .style("transform", "translate3d(0px, -15px, 0px)")
      .text(loc)
      .transition()
      .ease(d3.easeQuadInOut)
      .duration(225)
      .delay(25)
      .style("transform", "translate3d(0px, 0px, 0px)");

/*    d3.select('#tooltip')
      .append('p')
      .classed("tooltip_sub", true)
      .style("color", "#fff")
      .style("font-size", "12px")
      .style("margin", "2px 0px")
      .style('font-family', 'Roboto')
      .text("click to continue");

*/

      d3.select('#tooltip')
        .append('div')
        .style('position', 'absolute')
        .style('left', '0px')
        .style('bottom', '0px')
        .style('background', '#212121')
        .style('width', '70%')
        .style("transform", "translate3d(0px, 4px, 0px) skewX(30deg)")
        .style('width', '70%')
        .style('height', '4px')
        .transition()
        .ease(d3.easeQuadInOut)
        .duration(300)
        .delay(125)
        .style("transform", "translate3d(0px, 0px, 0px) skewX(30deg)");;



    // appending circles on top of hovered landmark
    d3.select('svg.voronoi').append('circle')
      .attr('class', 'interCirc')
      .attr('cx', d => X * multiplier)
      .attr('cy', d => Y * multiplier)
      .style('fill', '#fff')
      .style('fill-opacity', .2)
      .transition()
      //.ease(d3.easeElastic)
      .duration(150)
      .attr('r', d => (radius * multiplier) * intCircScale)
      .style('stroke-width', d => strokeSScale(radius) + 'px')
      .style('stroke-opacity', 0.5)

    // raise voronoi regions so that interactivity can maintain
    clippedCircs.raise();
  })

  // remove the interaction circles once the mouse goes away
  clippedCircs.on('mouseout', function(d, i){
    d3.select('svg.voronoi').selectAll('circle.interCirc').remove();
    if (window.innerWidth > 1024) {
      if (matches( document.querySelector( "#tooltip" ), ':hover' )) {
        d3.select('#tooltip').on('mouseout', function(d, i) {
          d3.select('.visContain').selectAll('.tooltip').remove();
        });
      }
      else {
        d3.select('.visContain').selectAll('.tooltip').remove();
      }
    }
    if (d3.select('.visContain')) {
      d3.select('.visContain').selectAll('.tooltip').remove();
    }
  })


  clippedCircs.on('mousedown', function(d, i){
    d3.select('svg.voronoi').select('circle.interCirc')
      .style('fill-opacity', 0.6);

    let linkTo = "/" + d.linkTo;
    console.log(linkTo);

    history.push(linkTo);
  })

  d3.selectAll('circle.voronoiCirc').on('mouseup', function(d, i){
    d3.select('svg.voronoi').select('circle.interCirc')
      .style('fill-opacity', 0.2);
  })

}

function matches( node, selector ) {

  // Most modern browsers support the ".matches" method. However, IE9+ uses a
  // non-standard method name. As such, we can fall-back to the IE version when
  // the standard one doesn't exist and that should cover all the modern
  // browsers that are in use.
  // --
  // READ MORE: https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
  var nativeMatches = ( node.matches || node.msMatchesSelector );

  // CAUTION: If an invalid pseudo-selector is used in Firefox or IE, the
  // browser will throw a SyntaxError, "is not a valid selector". It will do
  // the same for .querySelector() as well, just an FYI.
  try {

    return( nativeMatches.call( node, selector ) );

  } catch ( error ) {

    // In the case of an error, we're going to assume it's a pseudo-selector
    // issue and NOT a general support issue (since we don't care about
    // really old browsers).
    return( false );

  }

}

export { readAndDraw };
